import { Box, Button, Stack, Typography } from '@mui/material'

import { ErrorInvalidTokenImage } from './ErrorInvalidTokenImage'
import { useActions } from './useActions'
import { useTexts } from './useTexts'

export function InvalidResetPasswordToken() {
  const texts = useTexts()
  const actions = useActions()

  return (
    <>
      <Stack direction="column" spacing={3} textAlign="center" alignItems="center">
        <Box>
          <ErrorInvalidTokenImage />
        </Box>
        <Stack direction="column" spacing={1}>
          <Typography variant="h6">{texts.title}</Typography>
          <Typography variant="body2">{texts.description}</Typography>
        </Stack>
        <Stack direction="row">
          <Button variant="contained" onClick={actions.onNavigateToLogin}>
            {texts.primaryAction}
          </Button>
        </Stack>
      </Stack>
    </>
  )
}
